module.exports = __webpack_public_path__ + "static/img/button_app_store.2cfdd0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/button_app_store.svg
// module id = 024W
// module chunks = 1